// Page docs (structure + permissions + flows): pages/home/README.md
// Make the site land on the Homepage by default
// Re-export the Home page so root (/) renders it
export { default } from "./home/index";